import { Navigate, Route, Routes } from 'react-router-dom';

import SignInView from '../views/SignInView/SignInView';
import AuthVerifyView from '../views/SignInView/AuthVerifyView';
import ProtectedRoute from './ProtectedRoute';
import ManageAccountView from '../views/ManageAccountView/ManageAccountView';
import ManageAccountTabsView from '../views/ManageAccountView/ManageAccountTabsView';
import NoMatchRoute from './NoMatchRoute';
import UsersView from '../views/UsersView/UsersView';
import CasesView from '../views/CasesView/CasesView';
import ClientsView from '../views/ClientsView/ClientsView';
import DefendantsView from '../views/DefendantsView/DefendantsView';
import FileManagerView from '../views/FileManagerView/FileManagerView';
import CommunicationsView from '../views/CommunicationsView/CommunicationsView';
import FinancialView from '../views/FinancialView/FinancialView';
import UsersCreateFormContainer from '../views/UsersView/UsersCreateFormContainer';
import UsersEditFormContainer from '../views/UsersView/UsersEditFormContainer';
import UsersAccountView from '../views/UsersView/UsersAccountView';
import DefendantsCreateFormContainer from '../views/DefendantsView/DefendantsCreateFormContainer';
import DefendantsEditFormContainer from '../views/DefendantsView/DefendantsEditFormContainer';
import PaginationProvider from '../providers/PaginationProvider';
import ClientCreateFormContainer from '../views/ClientsView/ClientCreateFormContainer';
import ClientsEditFormContainer from '../views/ClientsView/ClientsEditFormContainer';
import ClientAccountView from '../views/ClientsView/ClientAccountView';
import CasesCreateFormContainer from '../views/CasesView/CasesCreateFormContainer';
import CasesEditFormContainer from '../views/CasesView/CasesEditFormContainer';
import CaseAccountView from '../views/CasesView/CaseAccountView';
import CreateDeductionFormContainer from '../views/PaymentsView/DeductionsView/CreateDeductionFormContainer';
// import CreateSettlementFormContainer from '../views/PaymentsView/SettlementsView/CreateSettlementFormContainer';
import DefendantAccountView from '../views/DefendantsView/DefendantAccountView';
import DeductionsView from '../views/PaymentsView/DeductionsView/DeductionsView';
import SettlementsView from '../views/PaymentsView/SettlementsView/SettlementsView';
import DeductionsEditFormContainer from '../views/PaymentsView/DeductionsView/DeductionsEditFormContainer';
import DeductionAccountView from '../views/PaymentsView/DeductionsView/DeductionAccountView';
import SettlementAccountView from '../views/PaymentsView/SettlementsView/SettlementAccountView';
import SettlementsEditFormContainer from '../views/PaymentsView/SettlementsView/SettlementsHomeView/SettlementsEditFormContainer';
import SettlementInitialRoute from '../views/PaymentsView/SettlementsView/SettlementInitialRoute';
import DataView from '../views/RequestsView/DataView/DataView';
import SignaturesView from '../views/RequestsView/SignaturesView/SignaturesView';
import DocumentsView from '../views/RequestsView/DocumentsView/DocumentsView';
import CreateDataFormContainer from '../views/RequestsView/DataView/CreateDataFormContainer';
import DataAccountView from '../views/RequestsView/DataView/DataAccountView';
// import CreateSignatureFormContainer from '../views/RequestsView/SignaturesView/CreateSignatureFormContainer';
import SignaturesAccountView from '../views/RequestsView/SignaturesView/SignaturesAccountView';
import CreateDocumentFormContainer from '../views/RequestsView/DocumentsView/CreateDocumentFormContainer';
import DocumentsAccountView from '../views/RequestsView/DocumentsView/DocumentsAccountView';
import SignaturesEditFormContainer from '../views/RequestsView/SignaturesView/SignaturesEditFormContainer';
import DocumentsEditFormContainer from '../views/RequestsView/DocumentsView/DocumentsEditFormContainer';
import DataEditFormContainer from '../views/RequestsView/DataView/DataEditFormContainer';
import AuthTemporaryPasswordView from '../views/SignInView/AuthTemporaryPasswordView';
import ForgotPasswordView from '../views/SignInView/ForgotPasswordView';
import ResetPasswordView from '../views/SignInView/ResetPasswordView';
import DocumentsTimeline from '../views/RequestsView/DocumentsView/DocumentsTimeline';
import SignaturesTimeline from '../views/RequestsView/SignaturesView/SignaturesTimeline';
import DataTimeline from '../views/RequestsView/DataView/DataTimeline';
import DeductionsTimeline from '../views/PaymentsView/DeductionsView/DeductionsTimeline';
import DeductionsRecovery from '../views/PaymentsView/DeductionsView/DeductionsRecovery';
import PaymentsAccountView from '../views/PaymentsView/PaymentsAccountView';
import RequestsAccountView from '../views/RequestsView/RequestsAccountView';
import SettlementsTimeline from '../views/PaymentsView/SettlementsView/SettlementsTimeline';
import CaseTypesView from '../views/CaseTypesView/CaseTypesView';
import LandingView from '../views/LandingView/LandingView';
// import ClientBankingView from '../views/ClientsView/clientBanking/ClientBankingView';
import PrivacyPolicyView from '../views/LandingView/LegalAgreementsView/PrivacyPolicyView';
import TermsConditionsView from '../views/LandingView/LegalAgreementsView/TermsConditionsView';
import TermsOfUseView from '../views/LandingView/LegalAgreementsView/TermsOfUseView';
import DataProcessingAbbendumView from '../views/LandingView/LegalAgreementsView/DataProcessingAbbendumView';
import DataPrivacyFrameworkNoticeView from '../views/LandingView/LegalAgreementsView/DataPrivacyFrameworkNoticeView';
import FormSnippetsView from '../views/FormSnippetsView/FormSnippetsView';
import QuestionnairesView from '../views/QuestionnairesView/QuestionnairesView';
import SettlementsDetailsView from '../views/PaymentsView/SettlementsView/SettlementsDetailsView/SettlementsDetailsView';
import DataSafetyView from '../views/DataSafetyView/DataSafetyView';
import SupportPageView from '../views/SupportPageView/SupportPageView';
import DeletePlaintiffAccountView from '../views/DataSafetyView/DeletePlaintiffAccountView';
import MobileAppPrivacyPolicyView from '../views/LandingView/LegalAgreementsView/MobileAppPrivacyPolicyView';
import EmailConfirmView from '../views/EmailConfirmView/EmailConfirmView';
import ConfirmBankingView from '../views/ConfirmBankingView/ConfirmBankingView';
import CreateSettlementFormContainer from '../views/PaymentsView/SettlementsView/CreateSettlementFormContainer';
import Confirm2FACodeView from '../views/SignInView/Confirm2FACodeView';
import FirmBankingAccountsView from '../views/FirmBankingView/FirmBankingAccountsView';
import ClientPayoutDetailsView from '../views/ClientsView/clientPayoutDetails/ClientPayoutDetailsView';
import FirmBankingView from '../views/FirmBankingView/FirmBankingView';
import FirmBankingTransactionsView from '../views/FirmBankingView/transactionsView/FirmBankingTransactionsView';
import AutoSweepPage from '../views/FirmBankingView/AutoSweepPage';
import AutoSweepBatchDetailsPage from '../views/FirmBankingView/AutoSweepBatchDetailsPage';
import VendorsAccountView from '../views/VendorsView/VendorsAccountView';
// import VendorAccountCreateEditView from '../views/VendorsView/VendorAccountCreateEditView';
import VendorCreateFormContainer from '../views/VendorsView/VendorCreateFormContainer';
import CreateBulkVendorContainer from '../views/VendorsView/CreateBulkVendorContainer';
import VendorEditFormContainer from '../views/VendorsView/VendorEditFormContainer';
import SettlementDraftView from '../views/PaymentsView/SettlementsView/SettlementDraft/SettlementDraftView';
import ActivityView from '../views/ActivityView/ActivityView';
import ActivityActorView from '../views/ActivityView/ActivityActorView';
import ChangelogFullView from '../views/ChangelogFullView/ChangelogFullView';
import DashboardView from '../views/DashboardView/DashboardView';
import DashboardAccountView from '../views/DashboardView/DashboardAccountView';
import PayoutsView from '../views/PayoutsView/PayoutsView';
import DraftsTab from '../views/PaymentsView/DraftsTab';
import CaseDraftsTab from '../views/CasesView/CaseDraftsTab';
import CaseLedgerView from '../views/CasesView/CaseLedgerView'
import QuickBooksCreateVendorPage from '../views/VendorsView/QuickBooksCreateVendorPage';

export const appRouteElements = (
  <>
    <Route index element={<LandingView />} />
    <Route path="privacy-policy" element={<PrivacyPolicyView />} />
    <Route path="terms-and-conditions" element={<TermsConditionsView />} />
    <Route path="terms-of-use" element={<TermsOfUseView />} />
    <Route path="data-processing-addendum" element={<DataProcessingAbbendumView />} />
    <Route path="data-privacy-framework-notice" element={<DataPrivacyFrameworkNoticeView />} />
    <Route path="data-safety" element={<DataSafetyView />} />
    <Route path="data-safety/delete-account" element={<DeletePlaintiffAccountView />} />
    <Route path="confirm-email" element={<EmailConfirmView />} />
    <Route path="confirm-banking" element={<ConfirmBankingView />} />

    <Route path="support" element={<SupportPageView />} />
    <Route path="app-privacy" element={<MobileAppPrivacyPolicyView />} />
    <Route
      path="account/autoseep"
      element={<Navigate to="/banking/accounts/autosweep" replace />}
    />
    <Route
      path="account/autosweep"
      element={<Navigate to="/banking/accounts/autosweep" replace />}
    />

    <Route path="sign-in" element={<SignInView />} />
    <Route path="auth/callback" element={<AuthVerifyView />} />
    <Route path="changePassword" element={<AuthTemporaryPasswordView />} />
    <Route path="forgotPassword" element={<ForgotPasswordView />} />
    <Route path="resetPassword" element={<ResetPasswordView />} />
    <Route path="confirm-2fa-code" element={<Confirm2FACodeView />} />

    <Route
      path="dashboard"
      element={
        <ProtectedRoute>
          <DashboardAccountView />
        </ProtectedRoute>
      }
    >
      <Route index element={<Navigate to="summary" />} />
      <Route
        path="summary"
        element={
          <ProtectedRoute moduleName="Dashboard">
            <DashboardView />
          </ProtectedRoute>
        }
      />
      <Route
        path="claimant-onboarding"
        element={
          <ProtectedRoute moduleName="Payments">
            <PayoutsView />
          </ProtectedRoute>
        }
      />
    </Route>

    <Route path="cases">
      <Route
        index
        element={
          <ProtectedRoute moduleName="Cases">
            <PaginationProvider key="casesView">
              <CasesView />
            </PaginationProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="create-case"
        element={
          <ProtectedRoute moduleName="Cases" permission="Create">
            <CasesCreateFormContainer />
          </ProtectedRoute>
        }
      />
      <Route
        path=":caseId"
        element={
          <ProtectedRoute moduleName="Cases">
            <CaseAccountView />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="home" />} />
        <Route
          path="home"
          element={
            <ProtectedRoute moduleName="Cases">
              <CasesEditFormContainer />
            </ProtectedRoute>
          }
        />
        <Route
          path="document-requests"
          element={
            <ProtectedRoute>
              <PaginationProvider>
                <DocumentsView />
              </PaginationProvider>
            </ProtectedRoute>
          }
        />
        <Route
          path="data-requests"
          element={
            <ProtectedRoute>
              <PaginationProvider>
                <DataView />
              </PaginationProvider>
            </ProtectedRoute>
          }
        />
        <Route
          path="signature-requests"
          element={
            <ProtectedRoute>
              <PaginationProvider>
                <SignaturesView />
              </PaginationProvider>
            </ProtectedRoute>
          }
        />
        <Route
          path="deductions"
          element={
            <ProtectedRoute moduleName="Payments">
              <PaginationProvider>
                <DeductionsView />
              </PaginationProvider>
            </ProtectedRoute>
          }
        />
        <Route
          path="settlements"
          element={
            <ProtectedRoute moduleName="Payments">
              <PaginationProvider>
                <SettlementsView />
              </PaginationProvider>
            </ProtectedRoute>
          }
        />
        <Route
          path="drafts"
          element={
            <ProtectedRoute moduleName="Payments">
              <PaginationProvider>
                <CaseDraftsTab />
              </PaginationProvider>
            </ProtectedRoute>
          }
        />
          <Route
            path="ledger"
            element={
              <ProtectedRoute moduleName="Payments">
                <PaginationProvider>
                  <CaseLedgerView />
                </PaginationProvider>
              </ProtectedRoute>
            }
          />
      </Route>
        
    </Route>
    <Route path="case-types">
      <Route
        index
        element={
          <ProtectedRoute moduleName="Case Types">
            <CaseTypesView />
          </ProtectedRoute>
        }
      />
    </Route>

    <Route path="clients">
      <Route
        index
        element={
          <ProtectedRoute moduleName="Clients">
            <PaginationProvider key="clientsView">
              <ClientsView />
            </PaginationProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="create-client"
        element={
          <ProtectedRoute moduleName="Clients" permission="Create">
            <ClientCreateFormContainer />
          </ProtectedRoute>
        }
      />
      <Route
        path=":clientId"
        element={
          <ProtectedRoute moduleName="Clients">
            <ClientAccountView />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="home" />} />
        <Route
          path="home"
          element={
            <ProtectedRoute moduleName="Clients">
              <ClientsEditFormContainer />
            </ProtectedRoute>
          }
        />
        <Route
          path="activity"
          element={
            <ProtectedRoute>
              <div>Page is in development</div>
            </ProtectedRoute>
          }
        />
        <Route
          path="cases"
          element={
            <ProtectedRoute moduleName="Cases">
              <PaginationProvider>
                <CasesView />
              </PaginationProvider>
            </ProtectedRoute>
          }
        />
        <Route
          path="payout-details"
          element={
            <ProtectedRoute moduleName="Clients" permission="Plaintiff Onboarding">
              <ClientPayoutDetailsView />
            </ProtectedRoute>
          }
        />
        {/* <Route
            path="banking"
            element={
              <ProtectedRoute>
                <ClientBankingView />
              </ProtectedRoute>
            }
          /> */}
      </Route>
    </Route>

    <Route path="defendants">
      <Route
        index
        element={
          <ProtectedRoute moduleName="Defendants">
            <PaginationProvider key="defendantsView">
              <DefendantsView />
            </PaginationProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="create-defendant"
        element={
          <ProtectedRoute moduleName="Defendants" permission="Create">
            <DefendantsCreateFormContainer />
          </ProtectedRoute>
        }
      />
      <Route
        path=":defendantId"
        element={
          <ProtectedRoute moduleName="Defendants">
            <DefendantAccountView />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="home" />} />
        <Route
          path="home"
          element={
            <ProtectedRoute moduleName="Defendants">
              <DefendantsEditFormContainer />
            </ProtectedRoute>
          }
        />
        <Route
          path="cases"
          element={
            <ProtectedRoute moduleName="Cases">
              <PaginationProvider>
                <CasesView />
              </PaginationProvider>
            </ProtectedRoute>
          }
        />
      </Route>
    </Route>

    <Route path="snippets">
      <Route
        index
        element={
          <ProtectedRoute>
            <FormSnippetsView />
          </ProtectedRoute>
        }
      />
    </Route>

    <Route path="questionnaires">
      <Route
        index
        element={
          <ProtectedRoute>
            <QuestionnairesView />
          </ProtectedRoute>
        }
      />
    </Route>

    <Route
      path="requests"
      element={
        <ProtectedRoute>
          <RequestsAccountView />
        </ProtectedRoute>
      }
    >
      <Route index element={<Navigate to="document-requests" />} />
      <Route path="document-requests">
        <Route
          index
          element={
            <ProtectedRoute>
              <PaginationProvider key="documentsView">
                <DocumentsView />
              </PaginationProvider>
            </ProtectedRoute>
          }
        />
      </Route>

      <Route path="signature-requests">
        <Route
          index
          element={
            <ProtectedRoute>
              <PaginationProvider key="signaturesView">
                <SignaturesView />
              </PaginationProvider>
            </ProtectedRoute>
          }
        />
      </Route>

      <Route path="data-requests">
        <Route
          index
          element={
            <ProtectedRoute>
              <PaginationProvider key="dataView">
                <DataView />
              </PaginationProvider>
            </ProtectedRoute>
          }
        />
      </Route>
    </Route>

    <Route path="requests">
      <Route
        path="create-document-request"
        element={
          <ProtectedRoute>
            <CreateDocumentFormContainer />
          </ProtectedRoute>
        }
      />
      <Route
        path="document-request/:documentId"
        element={
          <ProtectedRoute>
            <DocumentsAccountView />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="home" />} />
        <Route
          path="home"
          element={
            <ProtectedRoute>
              <DocumentsEditFormContainer />
            </ProtectedRoute>
          }
        />
        <Route
          path="timeline"
          element={
            <ProtectedRoute>
              <DocumentsTimeline />
            </ProtectedRoute>
          }
        />
      </Route>

      {/* <Route
          path="create-signature-request"
          element={
            <ProtectedRoute>
              <CreateSignatureFormContainer />
            </ProtectedRoute>
          }
        /> */}
      <Route
        path="signature-request/:signatureId"
        element={
          <ProtectedRoute>
            <SignaturesAccountView />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="home" />} />
        <Route
          path="home"
          element={
            <ProtectedRoute>
              <SignaturesEditFormContainer />
            </ProtectedRoute>
          }
        />
        <Route
          path="timeline"
          element={
            <ProtectedRoute>
              <SignaturesTimeline />
            </ProtectedRoute>
          }
        />
      </Route>

      <Route
        path="create-data-request"
        element={
          <ProtectedRoute>
            <CreateDataFormContainer />
          </ProtectedRoute>
        }
      />
      <Route
        path="data-request/:dataId"
        element={
          <ProtectedRoute>
            <DataAccountView />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="home" />} />
        <Route
          path="home"
          element={
            <ProtectedRoute>
              <DataEditFormContainer />
            </ProtectedRoute>
          }
        />
        <Route
          path="timeline"
          element={
            <ProtectedRoute>
              <DataTimeline />
            </ProtectedRoute>
          }
        />
      </Route>
    </Route>

    <Route
      path="payments"
      element={
        <ProtectedRoute>
          <PaymentsAccountView />
        </ProtectedRoute>
      }
    >
      <Route index element={<Navigate to="settlements" />} />
      <Route path="deductions">
        <Route
          index
          element={
            <ProtectedRoute moduleName="Payments">
              <PaginationProvider key="deductionsView">
                <DeductionsView />
              </PaginationProvider>
            </ProtectedRoute>
          }
        />
      </Route>
      <Route path="settlements">
        <Route
          index
          element={
            <ProtectedRoute moduleName="Payments">
              <PaginationProvider key="settlementsView">
                <SettlementsView />
              </PaginationProvider>
            </ProtectedRoute>
          }
        />
      </Route>
      <Route path="drafts">
        <Route
          index
          element={
            <ProtectedRoute moduleName="Payments">
              <PaginationProvider key="draftsView">
                <DraftsTab />
              </PaginationProvider>
            </ProtectedRoute>
          }
        />
      </Route>
    </Route>

    <Route path="payments">
      <Route
        path="create-deduction"
        element={
          <ProtectedRoute moduleName="Payments" permission="Create">
            <CreateDeductionFormContainer />
          </ProtectedRoute>
        }
      />
      <Route
        path="deduction/:deductionId"
        element={
          <ProtectedRoute moduleName="Payments">
            <DeductionAccountView />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="home" />} />
        <Route
          path="home"
          element={
            <ProtectedRoute moduleName="Payments">
              <DeductionsEditFormContainer />
            </ProtectedRoute>
          }
        />
        <Route
          path="timeline"
          element={
            <ProtectedRoute moduleName="Payments">
              <DeductionsTimeline />
            </ProtectedRoute>
          }
        />
        <Route
          path="recovery"
          element={
            <ProtectedRoute moduleName="Payments">
              <PaginationProvider key="deductionRecovery">
                <DeductionsRecovery />
              </PaginationProvider>
            </ProtectedRoute>
          }
        />
      </Route>

      <Route
        path="create-settlement"
        element={
          <ProtectedRoute moduleName="Payments" permission="Create Settlement">
            <CreateSettlementFormContainer />
          </ProtectedRoute>
        }
      />
      <Route
        path="settlement/:settlementId"
        element={
          <ProtectedRoute moduleName="Payments">
            <SettlementAccountView />
          </ProtectedRoute>
        }
      >
        <Route index element={<SettlementInitialRoute />} />
        <Route
          path="home"
          element={
            <ProtectedRoute moduleName="Payments">
              <SettlementsEditFormContainer />
            </ProtectedRoute>
          }
        />
        <Route
          path="details"
          element={
            <ProtectedRoute moduleName="Payments">
              <SettlementsDetailsView />
            </ProtectedRoute>
          }
        />
        <Route
          path="timeline"
          element={
            <ProtectedRoute moduleName="Payments">
              <SettlementsTimeline />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route
        path="settlement-draft"
        element={
          <ProtectedRoute moduleName="Payments" permission="Create Settlement">
            <SettlementDraftView />
          </ProtectedRoute>
        }
      />
    </Route>

    <Route
      path="payouts"
      element={
        <ProtectedRoute moduleName="Payments">
          <Navigate to="/dashboard/claimant-onboarding" replace />
        </ProtectedRoute>
      }
    />

    <Route
      path="file-manager"
      element={
        <ProtectedRoute>
          <FileManagerView />
        </ProtectedRoute>
      }
    />

    <Route
      path="communications"
      element={
        <ProtectedRoute>
          <CommunicationsView />
        </ProtectedRoute>
      }
    />

    <Route
      path="financial"
      element={
        <ProtectedRoute>
          <FinancialView />
        </ProtectedRoute>
      }
    />

    <Route path="users">
      <Route
        index
        element={
          <ProtectedRoute moduleName="Users">
            <PaginationProvider key="usersView">
              <UsersView />
            </PaginationProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="create-user"
        element={
          <ProtectedRoute moduleName="Users" permission="Create">
            <UsersCreateFormContainer />
          </ProtectedRoute>
        }
      />
      <Route
        path=":lawyerId"
        element={
          <ProtectedRoute moduleName="Users">
            <UsersAccountView />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="home" />} />
        <Route
          path="home"
          element={
            <ProtectedRoute moduleName="Users">
              <UsersEditFormContainer />
            </ProtectedRoute>
          }
        />
        <Route
          path="activity"
          element={
            <ProtectedRoute moduleName="Users">
              <div>Page is in development</div>
            </ProtectedRoute>
          }
        />
      </Route>
    </Route>

    <Route
      path="manage-account"
      element={
        <ProtectedRoute>
          <ManageAccountTabsView />
        </ProtectedRoute>
      }
    >
      <Route index element={<Navigate to="home" />} />
      <Route
        path="home"
        element={
          <ProtectedRoute>
            <ManageAccountView tab="home" />
          </ProtectedRoute>
        }
      />
      <Route
        path="api-service"
        element={
          <ProtectedRoute moduleName="API Service">
            <ManageAccountView tab="api-service" />
          </ProtectedRoute>
        }
      />
    </Route>

    <Route
      path="banking"
      element={
        <ProtectedRoute moduleName="Banking">
          <FirmBankingView />
        </ProtectedRoute>
      }
    >
      <Route index element={<Navigate to="accounts" />} />
      <Route path="accounts">
        <Route
          index
          element={
            <ProtectedRoute>
              <FirmBankingAccountsView />
            </ProtectedRoute>
          }
        />
        <Route
          path="autosweep"
          element={
            <ProtectedRoute>
              <AutoSweepPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="autosweep/batches/:batchCode"
          element={
            <ProtectedRoute>
              <AutoSweepBatchDetailsPage />
            </ProtectedRoute>
          }
        />
      </Route>

      <Route path="transactions">
        <Route
          index
          element={
            <ProtectedRoute>
              <PaginationProvider key="bankingTransactionsView">
                <FirmBankingTransactionsView />
              </PaginationProvider>
            </ProtectedRoute>
          }
        />
      </Route>
    </Route>

    <Route path="vendors">
      <Route
        index
        element={
          <ProtectedRoute moduleName="Vendors">
            <PaginationProvider key="vendorsView">
              <VendorsAccountView />
            </PaginationProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="add-vendor-account"
        element={
          <ProtectedRoute moduleName="Vendors" permission="Create">
            <VendorCreateFormContainer />
          </ProtectedRoute>
        }
      />
      <Route
        path="create-quickbooks-vendor-account"
        element={
          <ProtectedRoute moduleName="Vendors" permission="Create">
            <QuickBooksCreateVendorPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="add-vendor-bulk-upload"
        element={
          <ProtectedRoute moduleName="Vendors" permission="Create">
            <PaginationProvider key="vendorBulkUploadView">
              <CreateBulkVendorContainer />
            </PaginationProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="edit-vendor-account/:accountId"
        element={
          <ProtectedRoute moduleName="Vendors">
            <PaginationProvider key="vendorEditView">
              <VendorEditFormContainer />
            </PaginationProvider>
          </ProtectedRoute>
        }
      />
    </Route>
    <Route path="activity">
      <Route
        index
        element={
          <ProtectedRoute moduleName="Activity">
            <PaginationProvider key="activityView">
              <ActivityView />
            </PaginationProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path=":actorType/:actorId"
        element={
          <ProtectedRoute moduleName="Activity">
            <PaginationProvider key="activityActorView">
              <ActivityActorView />
            </PaginationProvider>
          </ProtectedRoute>
        }
      />
    </Route>

    <Route path="changelog/full" element={<ChangelogFullView />} />

    <Route path="*" element={<NoMatchRoute />} />
  </>
);

const AppRoutes = () => <Routes>{appRouteElements}</Routes>;

export default AppRoutes;
